<app-layout>
  <div class="loading">
    <app-spinner></app-spinner>
  </div>
</app-layout>